export const nameRegex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'’ʼ\-]+( [a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'’ʼ\-]+)*$/u;
export const numbersOnlyRegex = /^[0-9.]+$/;
export const zipCodeRegex = /^\d{5}(?:-\d{4})?$/;
export const phoneRegex = /\d+/;
export const ibanRegex = /^\d{24,}$/;
export const passwordRegex = /^(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?\W)(?!.*\s).{8,}$/;
export const idsRegex = /^\d{4}$/;
export const phoneSymbolsClearRegex = /[()\-\s_]/g;

export const emailRegex = /^[\w.\-_=+&%~]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)+$/;
export const taxCodeRegex = /^\d{8}$/;
export const taxIpnRegex = /^\d{10}$/;

export const urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,}(\/[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/i;

export const facebookRegex = /^https:\/\/(www.)?facebook.com\/[A-Za-z0-9.]+$/;
export const instagramRegex = /^https:\/\/(www.)?instagram.com\/[A-Za-z0-9_.]+$/;
export const twitterRegex = /^https:\/\/(twitter.com|x.com)\/[A-Za-z0-9_]+$/;
export const tiktokRegex = /^https:\/\/(www.)?tiktok.com\/@[A-Za-z0-9_.]+$/;
export const youtubeRegex = /^https:\/\/(www.)?(youtube.com|youtu.be)\/@[A-Za-z0-9_.]+$/;

export const slugRegex = /^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/;
export const skuRegex = /^[a-zA-Zа-яА-Я0-9][a-zA-Zа-яА-Я0-9\s-]*$/;
export const externalIdRegex = /^[A-Za-z0-9_-]+$/;
